<template>
	<div class="content-zsy">
		<div class="widget-location">
			<h3>쿠폰</h3>
		</div>
		
		<div class="list-top">
			<div class="page-info">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>
		
		<el-table
			    :data="tableData"
			    stripe empty-text="데이타가 없습니다."
			    style="width: 100%">
		<!-- 	    <el-table-column
			      type="index"
			      label="순번"
			      width="80">
			    </el-table-column> -->
				<el-table-column
				  label="확인"
				  width="100">
				</el-table-column>
				<el-table-column
				  label="제목">
					<template slot-scope="scope">	     
						<i class="el-icon-s-promotion"></i> 
						<span style="cursor:pointer;" > {{ scope.row.title }}</span>				           
					</template>
				</el-table-column>
				<el-table-column
				  prop="discount"
				  label="할인"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="createtime"
				  label="남은기간"
				  width="150">
				</el-table-column>
			</el-table>
			<div class="page">
				<el-pagination
					layout="prev, pager, next" :page-size="20"
					:total="total"  @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return{
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
		}
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		.page{
			padding-bottom: 20px;
		}
	}
</style>